import { FileText } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { GUIDES, COUNTIES } from "@/data";
import { LeadDialog } from "@/components/LeadForm";

export default function Resources() {
  return (
    <div className="bg-cream pt-28 pb-24 px-6 md:px-12 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <Reveal><p className="font-mono text-xs uppercase tracking-[0.3em] text-green mb-4">Resource Center</p></Reveal>
        <Reveal delay={0.1}><h1 className="font-serif text-5xl md:text-6xl text-navy tracking-tighter mb-3">Free guides & checklists</h1></Reveal>
        <Reveal delay={0.15}><p className="text-charcoal/70 mb-12 max-w-lg">Request any guide below and we'll email it to you. Placeholder resources for demonstration.</p></Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {GUIDES.map((g, i) => (
            <Reveal key={g} delay={(i % 6) * 0.04}>
              <div className="bg-white rounded-2xl p-7 border border-black/5 h-full flex flex-col">
                <FileText className="text-gold mb-4" size={26} />
                <h3 className="font-serif text-xl text-navy mb-4 flex-1">{g}</h3>
                <LeadDialog type="guide" source={`guide-${g}`} title={`Get: ${g}`}
                  successMsg="Thanks! Your guide is on its way to your inbox."
                  extraFields={[
                    { name: "interest", label: "Are you a buyer, seller, or both?", type: "select", options: ["Buyer", "Seller", "Both"] },
                    { name: "county", label: "County of interest", type: "select", options: COUNTIES.map((c) => c.name) },
                  ]}
                  trigger={<button data-testid={`guide-${i}`} className="bg-navy text-cream text-sm font-semibold rounded-full py-3 hover:bg-navy/90 transition-colors">Download Guide</button>} />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
